import { useEffect } from 'react';

const SITE_URL = 'https://jogolinga.app';

const setMeta = (selector: string, attr: 'name' | 'property', key: string, content: string) => {
  let el = document.head.querySelector<HTMLMetaElement>(selector);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
};

// Met à jour titre, description, URL canonique et balises Open Graph lors de
// la navigation côté client (le pré-rendu statique les écrit déjà dans le HTML).
// noindex : pour la page 404, afin qu'elle ne soit jamais indexée.
export const usePageMeta = (title: string, description: string, path: string, noindex = false) => {
  useEffect(() => {
    // Titre vide : la page délègue à <NotFound />, qui pose ses propres balises.
    if (!title) return;
    document.title = title;
    setMeta('meta[name="description"]', 'name', 'description', description);
    setMeta('meta[property="og:title"]', 'property', 'og:title', title);
    setMeta('meta[property="og:description"]', 'property', 'og:description', description);
    setMeta('meta[property="og:url"]', 'property', 'og:url', SITE_URL + path);
    setMeta('meta[name="robots"]', 'name', 'robots', noindex ? 'noindex, follow' : 'index, follow');

    let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = SITE_URL + path;
  }, [title, description, path, noindex]);
};
